import { Control, FieldPath, FieldValues, useWatch } from 'react-hook-form';
import cn from 'classnames';
import { getPasswordRequirementState } from 'utils';
import { CheckRulesOffIcon_16, CheckRulesOnIcon_16 } from 'assets/icons';
import messages from './PasswordRulesModal.messages';
import styles from './PasswordRulesModal.module.css';

type Props<T extends FieldValues> = {
  name: FieldPath<T>;
  control: Control<T>;
  isShow: boolean;
};
type IconProps = {
  iconActive: boolean;
};

const PasswordRulesModal = <T extends FieldValues>({
  name,
  control,
  isShow,
}: Props<T>): JSX.Element | null => {
  const value = useWatch({
    control,
    name,
  });

  const passwordRules = getPasswordRequirementState(value);
  const CheckRulesIcon = ({ iconActive }: IconProps): JSX.Element | null =>
    iconActive ? (
      <CheckRulesOnIcon_16 className={styles.rules__icon} />
    ) : (
      <CheckRulesOffIcon_16 className={styles.rules__icon} />
    );

  if (isShow === false) return null;
  return (
    <div className={styles.rules}>
      <h3 className={styles.rules__title}>{messages.title}</h3>
      <span
        className={cn(
          styles.rules__option,
          passwordRules.matchLength && styles.rules__option_active,
        )}
      >
        <CheckRulesIcon iconActive={passwordRules.matchLength} />
        {messages.matchLength}
      </span>
      <span
        className={cn(
          styles.rules__option,
          passwordRules.includeUppercase && styles.rules__option_active,
        )}
      >
        <CheckRulesIcon iconActive={passwordRules.includeUppercase} />
        {messages.includeUppercase}
      </span>
      <span
        className={cn(
          styles.rules__option,
          passwordRules.includeLowercase && styles.rules__option_active,
        )}
      >
        <CheckRulesIcon iconActive={passwordRules.includeLowercase} />
        {messages.includeLowercase}
      </span>
      <span
        className={cn(
          styles.rules__option,
          passwordRules.includeNumber && styles.rules__option_active,
        )}
      >
        <CheckRulesIcon iconActive={passwordRules.includeNumber} />
        {messages.includeNumber}
      </span>
      <span
        className={cn(
          styles.rules__option,
          passwordRules.includeSpecialSymbol && styles.rules__option_active,
        )}
      >
        <CheckRulesIcon iconActive={passwordRules.includeSpecialSymbol} />
        {messages.includeSpecialSymbol}
      </span>
    </div>
  );
};

export default PasswordRulesModal;
